import SvgIcon, { type SvgIconProps } from 'LuxKit/SvgIcon'

function LineRowSingleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fillRule="evenodd" clipRule="evenodd" d="M20 7C21.1046 7 22 7.89543 22 9V15C22 16.1046 21.1046 17 20 17H4C2.89543 17 2 16.1046 2 15V9C2 7.89543 2.89543 7 4 7H20ZM4 15H20V9H4V15Z" fill="currentColor" />
  </SvgIcon>
}

export default LineRowSingleIcon
